import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DataGrid, GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { LinearProgress } from '@mui/material';
import { Stack } from '@mui/system';

interface IAccordionProps {
  columns: GridColDef[][];
  isLoading: boolean;
  headers: string[];
  rows: GridRowsProp;
  addPagination?: boolean
}
export const CustomDataGrid = (
  { columns, rows, isLoading, rowsPerPageOptions, pageSize, addPagination}: any
) => { 
  const [_pageSize, setPageSize] = React.useState<number>(pageSize);
  return (
    <DataGrid
      onPageSizeChange={(newPageSize: number) => setPageSize(newPageSize)}
      pageSize={_pageSize}
      rowsPerPageOptions={rowsPerPageOptions}
      disableColumnMenu
      hideFooter={!addPagination}
      disableSelectionOnClick
      autoHeight
      getRowId={(row) => JSON.stringify(row)}
      rows={rows}
      columns={columns}
      loading={isLoading}
      headerHeight={80}
      componentsProps={{
        pagination: {
          SelectProps: {
            MenuProps: {
              disablePortal: true,
            }
          }
        }
      }}
      components={{
        LoadingOverlay: LinearProgress,
        NoRowsOverlay: () => (
          <Stack height='100%' alignItems='center'
            justifyContent='center'>
            Δεν υπάρχουν εγγραφές
          </Stack>
        )
      }}
      sx={{
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: '#F2F2F2',
          fontSize: 16
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          textOverflow: 'clip',
          whiteSpace: 'break-spaces',
          lineHeight: 1
        },
        '& .MuiDataGrid-columnHeader: focus': {
          outline: 'none'
        },
        '& .MuiDataGrid-cell': {
          textOverflow: 'clip',
          whiteSpace: 'break-spaces',
          lineHeight: 1
        }
      }}
    />
  );
};

const AccordionControlled = (props: IAccordionProps) => {
  const { columns, rows, isLoading, headers, addPagination } = props;
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded
        ? panel
        : false);
    };

  return (
    <>
      {
        headers.map((header: string, index: number) => {
          return (
            <Accordion key={header} expanded={expanded === `panel${index}`}
              onChange={handleChange(`panel${index}`)}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}bh-content`}
                id={`panel${index}bh-header`}
              >
                <Typography variant='h4' sx={{ width: '33%', flexShrink: 0 }}>
                  {header}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {CustomDataGrid(
                  {columns: columns[index],
                    rowsPerPageOptions: [10, 20, 50],
                    pageSize: 10,
                    rows: rows[index],
                    isLoading,
                    addPagination}
                )}
              </AccordionDetails>
            </Accordion>
          );
        })
      }
    </>
  );
};

export default AccordionControlled;